import { render, staticRenderFns } from "./CourseVariationTable.vue?vue&type=template&id=3983982a"
import script from "./CourseVariationTable.vue?vue&type=script&lang=js"
export * from "./CourseVariationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports